(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  // Calculate delivery date (current date + 2 business days, skipping weekends)
  function calculateDeliveryDate() {
    const today = new Date();
    let deliveryDate = new Date(today);
    let daysToAdd = 2;
    
    // Add business days, skipping weekends
    while (daysToAdd > 0) {
      deliveryDate.setDate(deliveryDate.getDate() + 1);
      const dayOfWeek = deliveryDate.getDay();
      // Skip weekends (0 = Sunday, 6 = Saturday)
      if (dayOfWeek !== 0 && dayOfWeek !== 6) {
        daysToAdd--;
      }
    }
    
    const options = { weekday: 'long', month: 'short', day: 'numeric' };
    return deliveryDate.toLocaleDateString('en-US', options);
  }

  // Add delivery dates to product cards
  document.addEventListener('DOMContentLoaded', function() {
    const deliveryDateString = calculateDeliveryDate();
    // Wait for content to load and then apply changes
    setTimeout(function() {
      const productCards = document.querySelectorAll('.featured-collection .card-wrapper, .collection .card-wrapper');
      
      productCards.forEach(card => {
        // Update delivery date in the new location
        const deliveryDateEl = card.querySelector('.delivery-date');
        if (deliveryDateEl) {
          deliveryDateEl.textContent = deliveryDateString;
        }
        
        // More aggressive price cleaning targeting actual HTML structure
        const priceItems = card.querySelectorAll('.price-item');
        priceItems.forEach(priceEl => {
          let priceText = priceEl.textContent || priceEl.innerHTML;
          if (priceText && priceText.includes('USD')) {
            priceText = priceText.replace(/From\s*/gi, '');
            priceText = priceText.replace(/\s*USD\s*/gi, '');
            priceText = priceText.replace(/\s*CAD\s*/gi, '');
            priceEl.textContent = priceText.trim();
          }
        });

        // Target price containers specifically
        const priceContainers = card.querySelectorAll('.price__container');
        priceContainers.forEach(container => {
          container.innerHTML = container.innerHTML.replace(/USD/gi, '').replace(/From\s+/gi, '');
        });
        
        // Add delivery date section to the last card__content
        const cardContents = card.querySelectorAll('.card__content');
        const lastCardContent = cardContents[cardContents.length - 1];
        
        if (lastCardContent && !lastCardContent.querySelector('.delivery-date-section')) {
          const deliverySection = document.createElement('div');
          deliverySection.className = 'delivery-date-section';
          deliverySection.innerHTML = `
            <div class="delivery-date-early">
              <p>Earliest Delivery</p>
            </div>
            <div class="delivery-date-text">
              ${deliveryDateString}
            </div>
          `;
          lastCardContent.appendChild(deliverySection);
        }
      });
    }, 1000); // Wait 1 second for full page load

    // Also run periodically to catch dynamically loaded content
    setInterval(function() {
      const productCards = document.querySelectorAll('.collection .card-wrapper:not([data-clothingspace-processed])');
      
      if (productCards.length > 0) {
        const deliveryDateString = calculateDeliveryDate();
        
        productCards.forEach(card => {
          card.setAttribute('data-clothingspace-processed', 'true');
          card.setAttribute('data-delivery-date', deliveryDateString);
          
          // Clean prices
          const priceItems = card.querySelectorAll('.price-item');
          priceItems.forEach(priceEl => {
            let priceText = priceEl.textContent;
            if (priceText && priceText.includes('USD')) {
              priceText = priceText.replace(/From\s*/gi, '').replace(/\s*USD\s*/gi, '');
              priceEl.textContent = priceText.trim();
            }
          });
          
          // Add delivery date
          const cardContents = card.querySelectorAll('.card__content');
          const lastCardContent = cardContents[cardContents.length - 1];
          
          if (lastCardContent && !lastCardContent.querySelector('.delivery-date-section')) {
            const deliverySection = document.createElement('div');
            deliverySection.className = 'delivery-date-section';
            deliverySection.innerHTML = `
              <div class="delivery-date-early">
                <p>Earliest Delivery</p>
              </div>
              <div class="delivery-date-text">
                ${deliveryDateString}
              </div>
            `;
            lastCardContent.appendChild(deliverySection);
          }
        });
      }
    }, 2000); // Check every 2 seconds

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  // Calculate delivery date (current date + 2 business days, skipping weekends)
  function calculateDeliveryDate() {
    const today = new Date();
    let deliveryDate = new Date(today);
    let daysToAdd = 2;
    
    // Add business days, skipping weekends
    while (daysToAdd > 0) {
      deliveryDate.setDate(deliveryDate.getDate() + 1);
      const dayOfWeek = deliveryDate.getDay();
      // Skip weekends (0 = Sunday, 6 = Saturday)
      if (dayOfWeek !== 0 && dayOfWeek !== 6) {
        daysToAdd--;
      }
    }
    
    const options = { weekday: 'long', month: 'short', day: 'numeric' };
    return deliveryDate.toLocaleDateString('en-US', options);
  }

  // Add delivery dates to product cards
  document.addEventListener('DOMContentLoaded', function() {
    const deliveryDateString = calculateDeliveryDate();
    // Wait for content to load and then apply changes
    setTimeout(function() {
      const productCards = document.querySelectorAll('.main-collection-product-grid .card-wrapper, .collection .card-wrapper');
      
      productCards.forEach(card => {
        // Update delivery date in the new location
        const deliveryDateEl = card.querySelector('.delivery-date');
        if (deliveryDateEl) {
          deliveryDateEl.textContent = deliveryDateString;
        }
        
        // Clean prices
        const priceItems = card.querySelectorAll('.price-item');
        priceItems.forEach(priceEl => {
          let priceText = priceEl.textContent || priceEl.innerHTML;
          if (priceText && priceText.includes('USD')) {
            priceText = priceText.replace(/From\s*/gi, '');
            priceText = priceText.replace(/\s*USD\s*/gi, '');
            priceText = priceText.replace(/\s*CAD\s*/gi, '');
            priceEl.textContent = priceText.trim();
          }
        });
      });
    }, 1000); // Wait 1 second for full page load
  });

  } catch(e) { console.error(e); }
})();
})();
